<template>
  <li class="breadcrumb" :class="{active: isActive, completed: completed}" :style="{ width: width + '%' }" @click.stop="click">
    <span class="mid"></span>
    <span class="front"></span>
    <p class="breadcrumb-step-name" :class="{completed: completed}">
      {{ header }}
    </p>
  </li>
</template>

<script>
export default {
  props: {
    index      : 0,
    position   : 0,
    width      : Number,
    header     : String
  },
  
  computed: {
    isActive() {
      return this.index == this.position;
    },
    completed() {
      return this.position > this.index;
    }
  },
  
  methods: {
    click() {
      this.$emit('breadcrumb-click');
    }
  }
}
</script>
<style>
  .show-info {
    visibility: visible;
    opacity: 1;
  }
</style>



// WEBPACK FOOTER //
// BreadcrumbElement.vue?2d125287